/**
 * RevealWords — text split into words for a staggered reveal. Screen readers
 * get the plain text once; the split words are hidden from them. Without
 * JavaScript (or with reduced motion) the words simply show.
 *
 * `hero` plays a CSS rise on load so the server-rendered hero never flashes;
 * otherwise useHomepageMotion animates `.reveal-word` when it scrolls in.
 */
import { Fragment } from "react";
import { cn } from "@ui/lib/utils";

export function RevealWords({
  text,
  hero = false,
}: Readonly<{ text: string; hero?: boolean }>) {
  const words = text.split(" ");
  return (
    <>
      <span className="sr-only">{text}</span>
      <span aria-hidden="true">
        {words.map((word, index) => (
          <Fragment key={`${word}-${index}`}>
            <span className="-mb-[0.1em] inline-block overflow-hidden pb-[0.1em] align-bottom">
              <span
                className={cn("reveal-word inline-block", hero && "hero-rise")}
                style={{ "--i": index } as React.CSSProperties}
              >
                {word}
              </span>
            </span>
            {index < words.length - 1 && " "}
          </Fragment>
        ))}
      </span>
    </>
  );
}
